// @flow
import styled from '@emotion/styled';
import { Link } from '@tablekit/typography';
import { BORDER_RADIUS, typography } from '@tablekit/theme';
import Button from '@tablekit/button';

export const DismissButton = styled(Link.withComponent('span'))`
  ${typography('L2')};
`;

export const CloseButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: ${BORDER_RADIUS}px;
`;
